import React, {useContext, useEffect, useState} from 'react'
import strings from '../../lang/strings'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {Page_settings} from '../../config/page_settings'
import {rootStore} from '../../mobx/store'
import {formatNumber} from '../../helper/common'
import CouponRegisterModal from '../control/modal/modal_coupon_register'

import DropdownRegister from '../../components/dropdown/register_drop'
// import Chat from '../../pages/chat/chat'

const SidebarLeft = (props) => {
  const context = useContext(Page_settings)
  const {menu, active, type, bjList, wineeList} = props
  let [dropBj, setDropbj] = useState(rootStore.getDropbj === -1 ? !!(rootStore.getFavBj && rootStore.getFavBj.length > 0) : rootStore.getDropbj === 1)
  let [dropAnalyst, setDropAnalyst] = useState(rootStore.getDropAnalyst === -1 ? !!(rootStore.getFavWinee && rootStore.getFavWinee.length > 0) : rootStore.getDropAnalyst === 1)
  let [dropBj1, setDropBj1] = useState(rootStore.getDropbj1 === -1 ? !!(bjList && bjList.length > 0) : rootStore.getDropbj1 === 1)
  let [dropWinee, setDropWinee] = useState(rootStore.getDropWinee === -1 ? !!(wineeList && wineeList.length > 0) : rootStore.getDropWinee === 1)
  let [showCouponModal, setShowCouponModal] = useState(false)

  useEffect(() => {
    if (rootStore.getDropbj === -1 && !!(rootStore.getFavBj && rootStore.getFavBj.length > 0)) {
      rootStore.setDropbj(1)
      setDropbj(true)
    }
  }, [rootStore.getFavBj])

  useEffect(() => {
    if (rootStore.getDropAnalyst === -1 && !!(rootStore.getFavWinee && rootStore.getFavWinee.length > 0)) {
      rootStore.setDropAnalyst(1)
      setDropAnalyst(true)
    }
  }, [rootStore.getFavWinee])

  useEffect(() => {
    if (rootStore.getDropbj1 === -1 && !!(bjList && bjList.length > 0)) {
      rootStore.setDropbj1(1)
      setDropBj1(true)
    }
  }, [bjList])

  useEffect(() => {
    if (rootStore.getDropWinee === -1 && !!(wineeList && wineeList.length > 0)) {
      rootStore.setDropWinee(1)
      setDropWinee(true)
    }
  }, [wineeList])

  const onclick = (e, item, index) => {
    if (index === active || !item.path) {
      e.preventDefault()
      if (item.logout) context.showLogout()
      if (item.signout) context.showSignout()
    }
  }

  const onCouponRegister = () => {
    setShowCouponModal(false)
    if (props.onCoupon) {
      props.onCoupon()
    }
  }

  const onPointPay = () => {
    context.showPointPay(
      (p) => {
        if (props.onPoint) {
          props.onPoint(p)
        }
      }
    )
  }

  const onBJ = (bj) => {
    if (props.onBJ) {
      props.onBJ(bj)
      return
    }
    context.post('data/bj_list', {bj_id: bj.mb_id},
      response => {
        const mb = response.bj
        if (mb != null) props.history.push(`/bj/detail/${mb.mb_id}`, { bjList: response.bj_list })
      }
    )
  }

  const onWinee = (winee) => {
    if (props.onWinee) {
      props.onWinee(winee)
      return
    }
    context.post('data/an_list', {an_id: winee.mb_id},
      response => {
        const mb = response.an
        if (mb != null) props.history.push('/analyst/detail', { info: mb, wineeList: response.winee_list })
      }
    )
  }

  const changeDropBj = (val) => {
    setDropbj(val)
    rootStore.setDropbj(val ? 1 : 0)
  }

  const changeDropAnalyst = (val) => {
    setDropAnalyst(val)
    rootStore.setDropAnalyst(val ? 1 : 0)
  }

  const changeDropBj1 = (val) => {
    setDropBj1(val)
    rootStore.setDropbj1(val ? 1 : 0)
  }

  const changeDropWinee = (val) => {
    setDropWinee(val)
    rootStore.setDropWinee(val ? 1 : 0)
  }

  const onNew = (idx) => {
    let urls = ['/my_data/analyst_new_game', '/my_data/analyst_new_betting', '/my_data/analyst_new_victory', '/my_data/analyst_new_daily', '/my_data/bj_new/0', '/my_data/bj_new/1', '/my_data/bj_new']
    props.history.push(urls[idx], {data: null})
  }

  return (
    <div id='sidebar_left' className='sidebar_left'>
      {!rootStore.isSignedIn &&
        <React.Fragment>
          <div className='sidebar_login'>
            <div className='sidebar-winee'>
              <img  style={{width : "59px"}} src={'/assets/image/ic-winee.png'}/>
            </div>
            <div className='sidebar_login_container'>
              <a className='btn btn-login fs-16 f-b d-center mt-10' href={'/login'}>{strings.login}</a>
              <div className='mt-14 text-center w-100'>
                <a className='fs-15 color-4c4c4d web_login_signup' href={'/find/0'}>{strings.find_id}</a>&nbsp;/&nbsp; 
                <a className='fs-15 color-4c4c4d web_login_signup' href={'/find/1'}>{strings.find_pwd}</a>
              </div>
              {/* <div className='mt-40 pt-20 text-center fs-18 f-m'>{strings.not_login}</div> */}
              <a className='mt-22 signup-btn fs-16 f-b w-100 d-center' href={'/signup'}>{`${strings.signup}${strings.do}`}</a>
            </div>
          </div>
        </React.Fragment>
      }
      {rootStore.isSignedIn &&
      <div className='sidebar_login'>
        <div className='sidebar-winee'>
          <img  style={{width : "59px"}} src={'/assets/image/ic-winee.png'}/>
          <div 
            className='alarm-animation' 
            style={{position : 'absolute', right : '16px', width : '48px', height : '48px', padding : '14px'}}
            onClick={()=> {props.history.push('/alarm_list')}}
            >
            <img  style={{width : "20px"}} src={'/assets/image/alarm_icon.png'}/>
            {rootStore.getAlarmCount > 0 && (
              <div className="alarm-badge">{`${rootStore.getAlarmCount > 9 ? '9+' : rootStore.getAlarmCount }`}</div>
            )}
          </div>
        </div>
        <div className='sidebar_login_container'>
        <div className='d-center'>
          <div className='flex-full fs-18 f-m color-3a3335'><u className='f-b'>{rootStore.getMe.mb_nick}</u> {strings.nim}</div>
          <button className='sidebar-logout btn btn-white fs-13 d-center' onClick={() => {context.showLogout()}}>
            {strings.logout}<img className='signout ml-10' src={'/assets/image/signout.png'} alt='' />
          </button>
        </div>
        <div className='d-center mt-12'>
          <div className='color-4c4c4d fs-16 f-m'>{strings.point}</div>
          <div className='flex-full color-0a3962 fs-16 f-b ml-6 text-line'>{formatNumber(rootStore.getMe.mb_point)}p</div>
          <div className='sidebar-cache d-center fs-14'>
            <a className='color-4c4c4d' onClick={() => {onPointPay()}}>{strings.po_charge}</a>
          </div>
        </div>
        <a className='btn-mypage mt-24 color-0f4c81 btn btn-white fs-15 f-sb w-100 d-center border-e4e9f2' href={'/mypage'}>{strings.mypage}</a>
          {rootStore.getMe.mb_lv > 1 &&
          <div className='btn-reg-data mt-24'>
            <DropdownRegister onRegister={(idx) => {onNew(idx)}} />
          </div>
          }
        </div>

      </div>
      }
      {/* {context.showChat === 'ON' && <Chat/>} */}
      {rootStore.isSignedIn &&
      <React.Fragment>
        <a href={'/pay_list'}>
          <div className='d-center cursor-point fav-bj mt-20'>
            <img className='like_on' src={'/assets/image/like_on.png'} alt='' />
            <div className='flex-full color-3a3335 fs-16 f-b ml-10'>{strings.pay_list}</div>
          </div>
        </a>

        <div className='d-center cursor-point fav-bj mt-20' onClick={() => changeDropBj(!dropBj)}>
          <img className='like_on' src={'/assets/image/like_on.png'} alt='' />
          <div className='flex-full color-3a3335 fs-16 f-b ml-10'>{strings.fav_bj}</div>
          <img className='a5_d' src={dropBj ? '/assets/image/a5_u.png' : '/assets/image/a5_d.png'} alt=''/>
        </div>
        {dropBj &&
        <PerfectScrollbar className={'dropdown-fav-item ' + ((rootStore.getFavBj && rootStore.getFavBj.length > 0) ? '' : 'pv-0')} options={{ suppressScrollX: true }}>
          {rootStore.getFavBj && rootStore.getFavBj.map((item, index) => {
            return (
              <a className='d-flex align-items-center w-100 hover-underline pt-7 pb-7' key={index} onClick={() => {onBJ(item)}}>
                <div className='fs-15 color-3a3335 f-m text-line'>{item.mb_nick} {strings.bj}<span className='fs-12 color-8f8f8f ml-12'>{item.mb_intro}</span></div>
              </a>
            )
          })}
        </PerfectScrollbar>
        }
        {/* <div className='d-center cursor-point fav-bj mt-20' onClick={() => changeDropAnalyst(!dropAnalyst)}>
          <img className='like_on' src={'/assets/image/like_on.png'} alt='' />
          <div className='flex-full color-3a3335 fs-16 f-b ml-10'>{strings.fav_analyst}</div>
          <img className='a5_d' src={dropAnalyst ? '/assets/image/a5_u.png' : '/assets/image/a5_d.png'} alt=''/>
        </div>
        {dropAnalyst &&
        <PerfectScrollbar className={'dropdown-fav-item ' + ((rootStore.getFavWinee && rootStore.getFavWinee.length > 0) ? '' : 'pv-0')} options={{ suppressScrollX: true }}>
          {rootStore.getFavWinee && rootStore.getFavWinee.map((item, index) => {
            return (
              <a className='d-flex align-items-center w-100 pt-7 pb-7' key={index} onClick={() => {onWinee(item)}}>
                <div className='fs-15 color-3a3335 f-m text-line'>{item.mb_nick} {strings.member}<span className='fs-12 color-8f8f8f ml-12'>{item.mb_intro1}</span></div>
                <div className='fs-15 color-3a3335 f-m text-line'>{strings.member} {item.mb_nick}</div>
              </a>
            )
          })}
        </PerfectScrollbar>
        } */}
        {menu &&
        <div className='mt-20'>
          {
            menu.map((item, index) => {
              if (item.bjcheck) {
                if (rootStore.getMe.mb_lv > 1) {
                  return (
                    <a key={index} href={(active !== index && item.path) ? item.path : ''} onClick={(e) => onclick(e, item, index)} className={'d-flex align-items-center sidebar-left-menu ' + (active === index ? 'active' : '')}>
                      <div className='flex-full fs-16 f-m'>{item.title}</div>
                      <img className='a5_d' src={active === index ? '/assets/image/a5_r_w.png' : '/assets/image/a5_r.png'} alt='' />
                    </a>
                  )
                }
                return null;
              }
              return (
                <a key={index} href={(active !== index && item.path) ? item.path : ''} onClick={(e) => onclick(e, item, index)} className={'d-flex align-items-center sidebar-left-menu ' + (active === index ? 'active' : '')}>
                  <div className='flex-full fs-16 f-m'>{item.title}</div>
                  <img className='a5_d' src={active === index ? '/assets/image/a5_r_w.png' : '/assets/image/a5_r.png'} alt='' />
                </a>
              )
            })
          }
        </div>
        }
        <CouponRegisterModal show={showCouponModal} toggle={() => {setShowCouponModal(!showCouponModal)}} onConfirm={()=> {onCouponRegister()}}/>
      </React.Fragment>
      }
      {type === 1 &&
      <React.Fragment>
        <div className={'d-center cursor-point dropdown-bj ph-40 mt-20 ' + (dropBj1 ? 'active' : '')} onClick={() => changeDropBj1(!dropBj1)}>
          <div className='flex-full fs-16 f-m'>{strings.bj_winee}</div>
          <img className='a5_d' src={dropBj1 ? '/assets/image/a5_d_w.png' : '/assets/image/a5_r.png'} alt='' />
        </div>
        {dropBj1 &&
        <PerfectScrollbar className='dropdown-bj-item fs-14 f-m' options={{ suppressScrollX: true }}>
          <a className='d-flex align-items-center color-3a3335 w-100' href={'/bj/list'}>{strings.all}</a>
          {bjList && bjList.map((item, index) => {
            return (
              <a className='d-flex align-items-center w-100 hover-underline' key={index} onClick={() => {onBJ(item)}}>
                <div className='color-9e9e9e'>{item.mb_nick} {strings.bj}</div>
                {item.mb_new == 1 && <img className='icon_new' src={'/assets/image/new.png'} alt='' />}
              </a>
            )
          })}
        </PerfectScrollbar>
        }
      </React.Fragment>
      }
      {false && type === 2 &&
      <React.Fragment>
        <div className={'d-center cursor-point dropdown-bj ph-40 mt-20 ' + (dropWinee ? 'active' : '')} onClick={() => changeDropWinee(!dropWinee)}>
          <div className='flex-full fs-16 f-m'>{strings.analyst_winee}</div>
          <img className='a5_d' src={dropWinee ? '/assets/image/a5_d_w.png' : '/assets/image/a5_r.png'} alt='' />
        </div>
        {dropWinee &&
        <PerfectScrollbar className='dropdown-bj-item fs-14 f-m' options={{ suppressScrollX: true }}>
          <a className='d-flex align-items-center color-3a3335 w-100' href={'/analyst/list'}>{strings.all}</a>
          {wineeList && wineeList.map((item, index) => {
            return (
              <a className='d-flex align-items-center w-100 hover-underline' key={index} onClick={() => {props.onWinee(item)}}>
                <div className='color-9e9e9e'>{strings.member} {item.mb_nick}</div>
                {item.mb_new == 1 && <img className='icon_new' src={'/assets/image/new.png'} alt='' />}
              </a>
            )
          })}
        </PerfectScrollbar>
        }
      </React.Fragment>
      }
    </div>
  )
}

export default SidebarLeft
